import { env } from '@/constant/env';

// Workspace colors arrive from the API as opaque strings. Validate before
// injecting one into an inline style — especially a composite declaration like
// the full-viewport `box-shadow` in WorkspaceScreenBorder, where a malformed
// value would corrupt the whole rule (and could flood the screen via 100vmax).
const HEX_COLOR = /^#(?:[0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;

export const safeHexColor = (
  color: string | null | undefined
): string | null => (color && HEX_COLOR.test(color) ? color : null);

// Every workspace highlight surface (screen border, navbar tint, kanban
// backdrop) applies the same policy: gated on the workflow-cards flag,
// sanitized before interpolation into inline CSS. Keeping the policy in one
// place means a consumer can't accidentally drop the flag gate or the
// sanitizer.
export const workspaceHighlightColor = (
  color: string | null | undefined
): string | null =>
  env.FEATURE_FLAGS.USE_WORKFLOW_CARDS ? safeHexColor(color) : null;

// Translucent wash of the highlight color for tinted surfaces (navbar). One
// definition so every tinted surface uses the same mix ratio and blend space.
export const workspaceHighlightWash = (
  color: string | null | undefined
): string | null => {
  const safe = workspaceHighlightColor(color);
  return safe ? `color-mix(in oklab, ${safe} 12%, transparent)` : null;
};
